module.exports = __webpack_public_path__ + "static/media/zeroItems_large.f297fcf5.png";